module.exports = __webpack_public_path__ + "static/Dropbox-66b5cb92db3e8ad59230922692c16325.png";